import { Component, OnInit } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {
  get formGroup() {
    return this.formRef ? this.formRef.control : null;
  }
  constructor(public formRef: ControlContainer) {}

  billingContactSame = false;

  ngOnInit(): void {}

  checkboxChanged(change: MatCheckboxChange) {
    if (change.checked) {
      this.formGroup.get('billingContact').disable();
      this.billingContactSame = true;
    } else {
      this.formGroup.get('billingContact').enable();
      this.billingContactSame = false;
    }
  }
}
